import { Accordion as MuiAccordion, AccordionDetails, AccordionSummary, Typography, Icon } from '@mui/material';
import { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

interface AccordionProps {
  id?: string | null | undefined;
  children: ReactNode;
  summary: string;
}

export const Accordion = ({ id, children, summary }: AccordionProps) => {
  const { trackClick } = useAnalytics();
  return (
    <StyledAccordion id={id ?? undefined}>
      <StyledAccordionSummary
        expandIcon={<Icon color='primary'>expand_more</Icon>}
        onClick={() => trackClick(eventName(summary))}
      >
        <Typography component='span'>{summary}</Typography>
      </StyledAccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  );
};

const StyledAccordion = styled(MuiAccordion)`
  border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  box-shadow: none;
  &::before {
    display: none;
  }
  &.MuiAccordion-root:first-of-type {
    border: none;
    border-radius: 0;
  }
  &.Mui-expanded {
    margin: 0;
    border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  margin: 0 !important;
  min-height: 48px !important;
  &.Mui-expanded {
    margin: 0 !important;
    min-height: 48px !important;
  }
  .MuiAccordionSummary-content {
    margin: 0 !important;
    &.Mui-expanded {
      margin: 0 !important;
    }
  }
`;
